import Vue from 'vue';
import Player from '@/app/Player.vue';
import router from '@/app/router/player';
import { i18n } from '@/app/plugins/i18n';
import VTooltip from 'v-tooltip';
import ToastPlugin from '@/lib/components/toast';
import helpers from '@/app/plugins/helpers';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import WorkspaceUtils from './utils/workspace-utils';
import SlideWidth from '@/lib/components/transitions/SlideWidth.vue';

declare let SENTRY_ENABLED: boolean;
declare let SENTRY_DSN: string;
declare let ENVIRONMENT: string;

if (SENTRY_ENABLED) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  });
  Sentry.configureScope(scope => {
    scope.setTag(
      'workspace_name',
      WorkspaceUtils.parseWorkspaceName(window.location.hostname)
    );
  });
}

Vue.component('t-slide-width', SlideWidth);

// library.add(fas);
Vue.use(VTooltip);
Vue.use(ToastPlugin);

Vue.use(helpers);

new Vue({
  el: '#player',
  router,
  i18n,
  render: h => h(Player)
});
